import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import { AudioVideoInmateActivity, InmateActivity } from '@reliance/types/models/InmateActivity';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

type InmateActivityFilters = PaginationFilters & {
  inmateId?: number;
  startDate?: string;
  endDate?: string;
};

type InmateActivityResponse = IPaginatedResponse<InmateActivity> & {
  supportingData?: {
    previousBalance?: number;
  };
};

export const useInmateActivitiesByInmateId = (
  inmateId: number | null | undefined,
  filters?: InmateActivityFilters
) => {
  return useAsync<InmateActivityResponse>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params: InmateActivityFilters = {
        inmateId: id,
        ...filters,
      };

      return api
        .get<InmateActivityResponse>('/inmate-account/activity', { params })
        .then((r) => r.data);
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId, filters]
  );
};

type AudioVideoInmateActivityFilters = PaginationFilters & {
  inmateId?: number;
  startDate?: string;
  endDate?: string;
};

type AudioVideoInmateActivityResponse = IPaginatedResponse<AudioVideoInmateActivity> & {
  supportingData?: {
    previousBalance?: number;
  };
};

export const useAudioVideoInmateActivitiesByInmateId = (
  inmateId: number | null | undefined,
  filters?: AudioVideoInmateActivityFilters
) => {
  return useAsync<AudioVideoInmateActivityResponse>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params: AudioVideoInmateActivityFilters = {
        inmateId: id,
        ...filters,
      };

      return api
        .get<AudioVideoInmateActivityResponse>('/inmate-account/audio-video/activity', { params })
        .then((r) => r.data);
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId, filters]
  );
};
